import { Card, List, Space, Typography } from "antd";
import "./style/index.scss";
import { useNavigate } from "react-router-dom";

const AdminPainel = (props: any) => {
  //hooks
  const navigate = useNavigate();

  return (
    <Space wrap align="start" className="spaceFin" direction="vertical">
      <List
        grid={{ gutter: 16 }}
        dataSource={props.list}
        className="listPainel listCaixa listFin"
        renderItem={(item: any, index) => (
          <List.Item key={index} onClick={() => navigate(`${props.icons[index].route}`)} style={{ cursor: "pointer" }} className="listItem">
            <Card key={index} variant="borderless">
              <div className="gridPainel">
                <Typography.Title level={4} className="textCardPainel">
                  Total de cadastros: {item}
                </Typography.Title>
                <div className="divAdmin">
                  <Typography.Title level={3}>{props.titles[index]}</Typography.Title>
                  {props.icons[index].icon}
                </div>
              </div>
            </Card>
          </List.Item>
        )}
      />
    </Space>
  );
};

export default AdminPainel;
